(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["p21-card-isle-product"]) return;
  try {
    
  if (!customElements.get('p21-card-isle')) {
    customElements.define('p21-card-isle', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        const form = this.querySelector('form');
        const code = this.querySelector('[data-code-input]');
        const error = this.querySelector('[data-code-error]');
        if (!form || !code || !error) return;
        this.dataset.initialized = 'true';
        const showError = () => {
          code.setCustomValidity(code.dataset.requiredMessage);
          code.setAttribute('aria-invalid', 'true');
          error.textContent = code.dataset.requiredMessage;
          error.hidden = false;
        };
        const clearError = () => {
          code.setCustomValidity('');
          code.removeAttribute('aria-invalid');
          error.textContent = '';
          error.hidden = true;
        };
        code.addEventListener('invalid', showError);
        code.addEventListener('input', clearError);
        form.addEventListener('submit', (event) => {
          code.value = code.value.trim();
          if (!code.value) {
            event.preventDefault();
            showError();
            code.focus();
            code.reportValidity();
            return;
          }
          clearError();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p21-signature-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('p21-signature-collection')) {
    customElements.define('p21-signature-collection', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelectorAll('[data-size-choices]').forEach(choices => { choices.hidden = false; });
        this.addEventListener('click', event => {
          const choice = event.target.closest('[data-size-choice]');
          if (!choice || !this.contains(choice)) return;
          const card = choice.closest('[data-card]');
          card.querySelectorAll('[data-size-choice]').forEach(button => {
            button.setAttribute('aria-pressed', String(button === choice));
          });
          const photo = card.querySelector('.p21-sc__card-image');
          if (photo && choice.dataset.image) {
            photo.srcset = choice.dataset.srcset;
            photo.src = choice.dataset.image;
            photo.alt = choice.dataset.imageAlt;
          }
          const price = card.querySelector('[data-price]');
          if (price) price.textContent = choice.dataset.price;
          if (choice.dataset.url) {
            card.querySelectorAll('[data-product-link]').forEach(link => { link.href = choice.dataset.url; });
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p21-signature-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('p21-signature-product')) {
    customElements.define('p21-signature-product', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const source = this.querySelector('[data-variants]');
        this.select = this.querySelector('[data-variant-select]');
        if (!source || !this.select) return;
        try { this.variants = JSON.parse(source.textContent); } catch { return; }
        this.ready = true;
        this.photos = [...this.querySelectorAll('[data-media-id]')];
        this.thumbs = [...this.querySelectorAll('[data-thumb-id]')];
        this.cards = [...this.querySelectorAll('[data-size-cards] [data-variant-id]')];
        this.submit = this.querySelector('[data-add-to-cart]');
        this.select.addEventListener('change', () => this.updateVariant(true));
        this.cards.forEach(card => card.addEventListener('click', () => {
          this.select.value = card.dataset.variantId;
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
        }));
        this.thumbs.forEach(thumb => thumb.addEventListener('click', () => this.showPhoto(thumb.dataset.thumbId, true)));
        this.updateVariant(false);
        const cards = this.querySelector('[data-size-cards]');
        if (cards) cards.hidden = false;
        if (cards || this.variants.length === 1) this.querySelector('[data-native-selector]').hidden = true;
        const thumbs = this.querySelector('[data-thumbs]');
        if (thumbs) thumbs.hidden = this.photos.length < 2;
      }
      updateVariant(announce) {
        const variant = this.variants.find(item => String(item.id) === this.select.value);
        if (!variant) return;
        this.cards.forEach(card => card.setAttribute('aria-pressed', String(card.dataset.variantId === String(variant.id))));
        this.querySelector('[data-product-price]').textContent = variant.price;
        const matching = this.photos.filter(photo => photo.dataset.mediaGroup === variant.group);
        this.visiblePhotos = matching.length ? matching : this.photos;
        const visibleIds = this.visiblePhotos.map(photo => photo.dataset.mediaId);
        this.thumbs.forEach(thumb => { thumb.hidden = !visibleIds.includes(thumb.dataset.thumbId); });
        const first = this.visiblePhotos.find(photo => photo.dataset.mediaId === String(variant.mediaId)) || this.visiblePhotos[0];
        if (first) this.showPhoto(first.dataset.mediaId, false);
        if (this.dataset.comingSoon !== 'true') {
          this.submit.disabled = !variant.available;
          this.submit.textContent = variant.available ? this.dataset.addLabel : this.dataset.unavailableLabel;
        }
        if (announce) {
          this.querySelector('[data-selection-status]').textContent = this.dataset.announcement.replace('[size]', variant.title).replace('[price]', variant.price);
          if (this.dataset.updateUrl === 'true') {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState(window.history.state, '', url);
          }
        }
      }
      showPhoto(id, animate) {
        const update = () => {
          this.photos.forEach(photo => { photo.hidden = photo.dataset.mediaId !== id; });
          this.thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.thumbId === id)));
        };
        if (animate && document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) document.startViewTransition(update);
        else update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
